import useGlobalState from '@components/Hooks/useGlobalState';
import Error from '@Shared/Error';
import React from 'react';

const ForgotPasswordError: React.FC = () => {

  const [store,] = useGlobalState();

  return store.password_sent === false ? (
    <Error>
      <h2>Error</h2>
      <p>An error occurred while processing your request.  Please contact your local CSAB administrator.</p>
    </Error>
  ) : null;
}

export default ForgotPasswordError;